import { useState, useEffect } from 'react';
import { DataServiceHookResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { useInvokeSWRService } from '@dxb-web-ui-framework/common/hooks';
import { isEmpty } from '@dxb-web-ui-framework/common/utils';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { useAuthorizationTransactionDetails, useInitiateMandateService } from '../../../contexts';
import { InitiateMandateResponseBody } from '../../../domain/Authorization/entities/InitiateMandateResponseDTO';

const useMandateInitiateService = (
  authAction: Nullable<string>,
  cancellationReason?: string,
  dealerRateRequest?: boolean,
  shouldInitiate: boolean = false,
): DataServiceHookResponse<InitiateMandateResponseBody> => {
  const [timestamp, setTimestamp] = useState<Nullable<string>>(null);
  const initiateMandateService = useInitiateMandateService()();
  const selectedAuthorizationTransactionDetails = useAuthorizationTransactionDetails();

  const shouldInitiateAuthorization =
    !isEmpty(selectedAuthorizationTransactionDetails) &&
    selectedAuthorizationTransactionDetails !== null &&
    authAction !== null &&
    (Boolean(authAction === 'approve') || Boolean(authAction === 'reject' && Boolean(cancellationReason))) &&
    Boolean(timestamp) &&
    shouldInitiate;

  useEffect(() => {
    if (!timestamp) {
      setTimestamp(new Date().toISOString());
    }
  }, [timestamp]);

  // Initiate Authorization
  return useInvokeSWRService<InitiateMandateResponseBody>(
    initiateMandateService,
    {
      appTransactionId: selectedAuthorizationTransactionDetails?.transactionId,
      accepted: authAction === 'approve' ? true : false,
      cancellationReason,
      orderCode: selectedAuthorizationTransactionDetails?.globalOrderId,
      dealerRateRequest: Boolean(dealerRateRequest),
      meta: { timestamp },
    },
    shouldInitiateAuthorization,
    'authorizationService.ExecuteMandate',
  );
};

export { useMandateInitiateService };
